"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.simpleDoctorSubtituteApiSchema = exports.doctorSubstituteApiRelationSchema = void 0;
const zod_1 = require("zod");
const address_schema_1 = require("../global/address.schema");
const api_1 = require("../global/api");
const french_department_1 = require("../global/french-department");
const profile_schema_1 = require("../global/profile.schema");
const doctor_substitute_document_1 = require("./doctor-substitute-document");
exports.doctorSubstituteApiRelationSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    type: (0, api_1.apiEntityTypeSchema)('doctor-substitutes'),
    attributes: zod_1.z.object({
        firstname: zod_1.z.string(),
        lastname: zod_1.z.string(),
        email: zod_1.z.string(),
        phoneNumber: zod_1.z.string().nullable().default(null),
        picture: profile_schema_1.pictureSchema,
        address: address_schema_1.addressSchema,
        orderRegistrationNumber: zod_1.z.string(),
        rppsNumber: zod_1.z.string(),
        dateOfBirth: zod_1.z.coerce.date(),
        thesis: zod_1.z.boolean(),
        installable: zod_1.z.boolean(),
        rhythm: zod_1.z.string().nullable().default(null),
        // Structured rhythm fields
        onSiteSlotsWithoutAssistant: zod_1.z.number().int().nullable().default(null),
        remoteSlotsWithoutAssistant: zod_1.z.number().int().nullable().default(null),
        onSiteSlotsWithAssistant: zod_1.z.number().int().nullable().default(null),
        remoteSlotsWithAssistant: zod_1.z.number().int().nullable().default(null),
        rhythmNote: zod_1.z.string().nullable().default(null),
        iban: zod_1.z.string(),
        bic: zod_1.z.string().nullable().default(null),
        signatureUrl: profile_schema_1.signatureUrlSchema,
        urssafNumber: zod_1.z.string().nullable().default(null),
        licenceNumber: zod_1.z.string().nullable().default(null),
        licenceExpiresAt: zod_1.z.coerce.date().nullable().default(null),
        licenceCouncilDepartmentCode: french_department_1.frenchDepartmentCodeSchema
            .nullable()
            .default(null),
        licenceDocument: doctor_substitute_document_1.doctorSubstituteDocumentApiSchema,
        rcpDocument: doctor_substitute_document_1.doctorSubstituteDocumentApiSchema,
        createdAt: zod_1.z.coerce.date(),
    }),
});
exports.simpleDoctorSubtituteApiSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    type: (0, api_1.apiEntityTypeSchema)('doctor-substitutes'),
    attributes: zod_1.z.object({
        firstname: zod_1.z.string(),
        lastname: zod_1.z.string(),
        phoneNumber: zod_1.z.string().nullable().default(null),
        picture: profile_schema_1.pictureSchema,
    }),
});
